module.exports = __webpack_public_path__ + "img/flag-MX.a2b13dbe.svg";